<template>
    <div>
        <payment-result-form id="PaymentResultForm"></payment-result-form>
        <checkout-modal id="CheckoutModal"></checkout-modal>
        <invoice-modal id="InvoiceModal"></invoice-modal>
        <confirmation-modal id="ConfirmationModal"></confirmation-modal>
        <appointment-fast-modal id="AppointmentFastModal"></appointment-fast-modal>
        <block-appointment-time-modal id="BlockAppointmentTimeModal"></block-appointment-time-modal>
    </div>
</template>

<script>
import PaymentResultForm from "@/Pages/Sales/PaymentResultForm";
import CheckoutModal from "@/Pages/Sales/CheckoutModal";
import InvoiceModal from "@/Pages/Sales/InvoiceModal";
import ConfirmationModal from '@/components/ConfirmationModal.vue';
import AppointmentFastModal from '@/Pages/Appointments/FastModal.vue';
import BlockAppointmentTimeModal from '@/Pages/Appointments/BlockAppointmentTimeModal.vue';

export default {
    components: {
        InvoiceModal,
        CheckoutModal,
        ConfirmationModal,
        PaymentResultForm,
        AppointmentFastModal,
        BlockAppointmentTimeModal
    },
    data() {
        return {
            appointmentDefaults: {
                appointmentAt: this.$moment().add(1, "day"),
                services: [{}]
            },
        }
    }
}
</script>
